export type RealmOutfitStatus = 'draft' | 'pending' | 'approved' | 'declined' | 'published' | 'unpublished';
export type RealmQueryOutfitStatus = 'decline' | 'publish';

export type RealmOutfitItem = {
  id: number,
  outfitId: number,
  sku: string,
  itemUrl: string,
  imageUrl: string,
  isSimilar: boolean,
  createdAt: string,
  updatedAt: string,
  isFocusSku: boolean
};

export type RealmOutfitItemResource = {
  id: number,
  sku: string,
  itemUrl: string,
  imageUrl: string,
  inStock: boolean,
  isValid: boolean,
  isSimilar: boolean,
  isPreOwned: boolean,
  isFocusSku: boolean
};

export type RealmOutfitTag = {
  id: string,
  title: string,
  type: 'regular' | 'gtl',
  genders?: Array<string>,
  isDeprecated?: boolean
};

export type RealmOutfitDeclinedReason = {
  text: string,
  date: string
};

export type RealmOutfitCaptions = {
  en?: string,
  de?: string
}

export interface RealmOutfitVideo {
  id: number,
  outfitId: number,
  url: string,
  contentType: string,
  thumbnailUrl: string,
  audioType: RealmOutfitAudioType | null,
  vimeo: null | VimeoResponse,
  isComplete: boolean,
  pipelineStatus: string
}

export interface VimeoResponse {
  link: string,
  status: 'in_progress' | 'complete' | 'error',
  privacy: string
}

export interface RealmOutfitRawVideo {
  outfitId: number,
  url: string,
  audioType: RealmOutfitAudioType | null,
  file: File
}

export interface RealmOutfitImage {
  url: string,
  sortOrder: number,
  name?: string
}

export type RealmOutfit = {
  id: number,
  name: string,
  numberOfItems?: number,
  emOutfitId: number,
  influencerId: number,
  items: Array<RealmOutfitItem>,
  status: RealmOutfitStatus,
  caption: string,
  tags: Array<RealmOutfitTag>,
  genders: Array<string>,
  captions: RealmOutfitCaptions,
  declineHistories: Array<RealmOutfitDeclinedReason>,
  images: Array<RealmOutfitImage>,
  video: null | RealmOutfitVideo,
  createdAt: string,
  updatedAt: string,
  reviewedAt: string,
  wmcShortLink?: string,
  publishedFrom?: string | null,
  publishedUntil?: string | null,
  publishedCountries: Array<string>,
  publishedError?: string,
  isSelected?: boolean
};

export type RealmOutfitForm = {
  id: number,
  emOutfitId: number,
  influencerId: number,
  items: Array<RealmOutfitItem | RealmOutfitItemResource>,
  deletedItemsIds: Array<number>,
  addeditems: Array<RealmOutfitItemResource>,
  status: RealmOutfitStatus,
  captions: RealmOutfitCaptions,
  tags: Array<string>,
  genders: Array<string>,
  images: Array<Omit<RealmOutfitImage, 'sortOrder'>>,
  video: null | RealmOutfitRawVideo | RealmOutfitVideo,
  initialAudioType: RealmOutfitAudioType | null,
  createdAt: string,
  updatedAt: string,
  reviewedAt: string,
  publishedFrom?: string | null,
  publishedUntil?: string | null,
  publishedCountries: Array<string>
};

export type RealmOutfitBrandForm = {
  id: number,
  name: string,
  deliverableId,
  declineHistories?: Array<RealmOutfitDeclinedReason>,
  items: Array<RealmOutfitItem | RealmOutfitItemResource>,
  images: Array<Omit<RealmOutfitImage, 'sortOrder'>>,
  tags: Array<string>,
  video: null | RealmOutfitRawVideo | RealmOutfitVideo,
  status: RealmOutfitStatus
}

export type RealmOutfitsQuery = {
  page: number,
  sort?: string,
  search?: string,
  influencerId?: string,
  status?: string
};

export type RealmOutfitImageProps = {
  width: number,
  height: number,
  ratio: number,
  size: number
};

export enum RealmOutfitAudioType {
  MUTED = 'muted',
  MUSIC = 'music',
  SPEECH = 'speech',
  MUSIC_AND_SPEECH = 'music_and_speech'
}
